import API from './api';

export default class AffiliateApi {
  static getList(params) {
    return API.get('/advertisers/affiliates', params);
  }

  static getRecent(params) {
    return API.get('advertisers/affiliates/recent', params);
  }

  static search(params) {
    return API.get('/advertisers/affiliates/search', params);
  }

  static getMarketSearch(params) {
    return API.get('/advertisers/affiliates/market_search', params);
  }
}
